import React from "react";

interface FlagIconProps {
  className?: string;
}

export const FlagIcon: React.FC<FlagIconProps> = ({ className = "" }) => {
  return (
    <div style={{ padding: "4px" }}>
      <svg
        className={className}
        width="24"
        height="24"
        viewBox="0 0 12 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.13318e-10 8.23459V14.6806C3.13318e-10 15.2176 0.45 15.6576 1 15.6576C1.55 15.6576 2 15.2176 2 14.6806V8.90259C3.17 8.56159 4.389 8.85759 5.768 9.19259C6.75 9.43059 7.804 9.68759 8.898 9.68759C9.77931 9.69698 10.6509 9.50296 11.445 9.12059C11.6139 9.03855 11.7562 8.91063 11.8558 8.75146C11.9554 8.5923 12.0081 8.40833 12.008 8.22059V1.46559C12.0086 1.29585 11.966 1.12875 11.884 0.980093C11.8021 0.831437 11.6836 0.706137 11.5397 0.616039C11.3959 0.525941 11.2314 0.474023 11.0619 0.465195C10.8924 0.456367 10.7234 0.49092 10.571 0.565587C9.226 1.21959 7.84 0.882587 6.24 0.494587C4.511 0.0745873 2.553 -0.400413 0.562 0.566587C0.393476 0.648696 0.251425 0.776521 0.152055 0.935479C0.0526841 1.09444 -4.69149e-06 1.27813 3.13318e-10 1.46559V8.23459Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
};
